import { render, staticRenderFns } from "./managementStandardOfFranchiseeDY.vue?vue&type=template&id=4d5b7c37&scoped=true"
import script from "./managementStandardOfFranchiseeDY.vue?vue&type=script&lang=js"
export * from "./managementStandardOfFranchiseeDY.vue?vue&type=script&lang=js"
import style0 from "./managementStandardOfFranchiseeDY.vue?vue&type=style&index=0&id=4d5b7c37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b7c37",
  null
  
)

export default component.exports